import styled from 'styled-components';

const OurSocialContactsStyle = styled.span`
	.followUsItem {
		display: inline-block;
		text-decoration: underline;
		letter-spacing: 0;

		> div {
			pointer-events: none;
		}
	}
`;

export default OurSocialContactsStyle;
